// extracted by mini-css-extract-plugin
module.exports = {"Button":"GenericButton_Button__1n1sW","Inverted":"GenericButton_Inverted__23zBe"};